import { getEntriesCount } from "@/functions/array";
import { getReadTicketListFromPersistence } from "../ticketsPersistence";
import type { Ticket } from "../ticketSharedTypes";
import type { AppDispatch } from "@/store/store";

const ADD_READ_TICKET = "tickets/ADD_READ_TICKET" as const;
const SET_TICKETS_READ = "tickets/SET_TICKETS_READ" as const;

interface AddReadTicketAction {
  type: typeof ADD_READ_TICKET;
  payload: string;
}

interface SetTicketsReadAction {
  type: typeof SET_TICKETS_READ;
  payload: string[];
}

type TicketsReadAction = AddReadTicketAction | SetTicketsReadAction;

const addReadTicket = (ticketId: string): AddReadTicketAction => ({
  type: ADD_READ_TICKET,
  payload: ticketId,
});

const setTicketsRead = (tickets: string[]): SetTicketsReadAction => ({
  type: SET_TICKETS_READ,
  payload: tickets,
});

export const setTicketRead = (ticketId: string) => {
  return (dispatch: AppDispatch) => dispatch(addReadTicket(ticketId));
};

const persistedData = getReadTicketListFromPersistence();
const initialState: string[] = persistedData ? JSON.parse(persistedData) : [];

export const reducer = (
  state = initialState,
  action: TicketsReadAction | { type: string } = { type: "" },
): string[] => {
  switch (action.type) {
    case ADD_READ_TICKET:
      return [...state, (action as AddReadTicketAction).payload];

    case SET_TICKETS_READ:
      return (action as SetTicketsReadAction).payload;

    default:
      return state;
  }
};

export function getUnreadTicketsCount(
  ticketsList: Ticket[] | { items: Ticket[] } | null | undefined,
  readTicketsIds: string[],
): number {
  const items = Array.isArray(ticketsList)
    ? ticketsList
    : ticketsList?.items || [];

  const currentTicketIds = items.map((ticket) => ticket.id);
  const unreadTicketIds = currentTicketIds.filter(
    (currentTicketId) => !readTicketsIds.includes(currentTicketId),
  );
  return getEntriesCount(unreadTicketIds);
}
